import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-svm-hier',
  template: `
    <p>
      svm-hier works!
    </p>
  `,
  styles: [
  ]
})
export class SvmHierComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
